import { createContext } from '@sajari/react-sdk-utils';

var _createContext = /*#__PURE__*/createContext({
  strict: true,
  name: 'PipelineContext'
}),
    Provider = _createContext[0],
    useContext = _createContext[1];

export { Provider, useContext };
//# sourceMappingURL=context.esm.js.map
